<template>
    <div class="leftbar">
        <div class="name">Henrik Davidsen</div>
        <div class="title">Quality Engineer | Software Developer</div>
        <div>
            <b-img src="@/assets/pictures/profile.jpg" fluid-grow alt="Profile picture"></b-img>
        </div>
        <Info :icon=false />
        <div style="padding-bottom: 5px">
            View resume
        </div>
        <div>
            <b-button @click="viewResume()" block>View PDF</b-button>
        </div>
        <div style="padding-bottom: 5px">
            Download resume
        </div>
        <div>
            <b-button @click="downloadFile('pdf')" block variant="danger">PDF</b-button>
        </div>
        <div>
            <b-button @click="downloadFile('docx')" block variant="primary">DOCX</b-button>
        </div>
    </div>
</template>

<script>
import Info from '@/components/Info'
import axios from 'axios'

export default {
    name: 'LeftBar',
    components: {
        Info
    },
    methods: {
        downloadFile(fileType) {
        axios({
            method: 'get',
            url: `https://henrikdavidsen.com/api/files/resume?fileType=${fileType}`,
            responseType: 'blob'
        })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `Resume - Henrik Davidsen.${fileType}`)
            document.body.appendChild(link)
            link.click()            
        })
        .catch((err) => console.log('Error occured: ' + err));
        },
        viewResume() {
            window.open('https://henrikdavidsen.com/api/files/resume', '_blank');
        }
    }
}
</script>

<style scoped>
    .leftbar {
        background: white;
        border-radius: 10px;
    }

    .leftbar > * {
        padding-bottom: 15px;
    }

    .name {
        font-weight: bold;
        font-size:x-large;
        padding-top: 10px;
        padding-bottom: 0px;
    }

    .title {
        color: #555555;
        font-size:10pt;
    }
</style>
